import CustomerInfo from './CustomerInfo'
import CustomerHighlight from './CustomerHighlight'
import PurchaseHistory from './PurchaseHistory'
import LoyaltyMembership from './LoyaltyMembership'
import RedeemHistory from './RedeemHistory'
import PointActivity from './PointActivity'
import {connect} from 'react-redux'
import styles from './style.css'
import {receiptCustomerRequest} from 'actions/customers/list'
import ReceiptInvoices from 'pages/Reports/Invoices/ReceiptInvoices'
import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt'

class CustomerDetail extends React.Component {
  constructor (props) {
    super(props)

    this.state = ({ showReceipt: false })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.list.customerDetail !== nextProps.list.customerDetail) {
      this.setState({ showReceipt: false })
    }
  }

  render () {
    let {customerDetail, receiptData} = this.props.list
    return (
      <div className={styles.wrapper}>
        <div className={styles['col-right-inner']}>
          <div className={styles['scrolled-area']}>
            { !this.state.showReceipt &&
              <div className='customer-info-box-container'>
                <CustomerInfo customerDetail={customerDetail} />
                <CustomerHighlight customerDetail={customerDetail} />
                <LoyaltyMembership customerDetail={customerDetail} />
                <RedeemHistory
                  customerDetail={customerDetail}
                  onClickHistory={this._openReceipt}
                  seeMore={this.props.showRedeemHistory}
                />
                <PointActivity
                  customerDetail={customerDetail}
                  onClickHistory={this._openReceipt}
                  seeMore={this.props.showPointActivity}
                />
                <PurchaseHistory
                  customerDetail={customerDetail}
                  onClickHistory={this._openReceipt}
                  seeMore={this.props.showPurchaseHistory}
                />
              </div>
            }
            {(receiptData && this.state.showReceipt && (receiptData.payment_type === 'invoice')) &&
              <div>
                <ReceiptInvoices invoiceDetail={receiptData} />
              </div>
            }
            {(receiptData && this.state.showReceipt && (receiptData.payment_type !== 'invoice')) &&
              <div className={styles['receipt-trx-container']}>
                <TransactionDetailReceipt paymentDetail={receiptData} />
              </div>
            }
          </div>
        </div>
        <div className={styles['mk-col-right-action-box-bottom']}>
          <button className='btn btn-primary pull-right' onClick={this._onClickDone}>
            Done
          </button>
        </div>
      </div>
    )
  }

  _onClickDone = () => {
    // on done receipt view, do not close right side
    if (this.state.showReceipt) {
      this.setState({showReceipt: false})
    } else {
      this.props.onClickDone()
    }
  }

  _openReceipt = (payment) => {
    this.setState({ showReceipt: true })
    const {customerDetail} = this.props.list
    this.props.dispatch(receiptCustomerRequest(payment, customerDetail))
  }
}

CustomerDetail.propTypes = {
  onClickDone: React.PropTypes.func
}

function mapStateToProps ({customers: {list}}) {
  return {
    list
  }
}

export default connect(mapStateToProps)(CustomerDetail)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/CustomerDetail.js